import { useHapticTarget } from '@/contexts/HapticsContext';
import { triggerHapticFeedback } from '@/lib/haptics';
import styles from './logo.module.less';

// T-I-L in Morse code (60ms unit): T=dah, I=dit·dit, L=dah·dit·dit·dit.
// Alternating vibration/pause durations for Android.
const TIL_PATTERN = [180, 180, 60, 60, 60, 180, 180, 60, 60, 60, 60, 60, 60];

interface LogoLockupProps {
  tilProps?: React.ComponentPropsWithRef<'span'>;
}

// Shared with the PWA launch splash (app/components/splash/pwa-splash.tsx) so
// the splash renders the identical brand lockup as the home page.
export function LogoLockup({ tilProps }: LogoLockupProps) {
  return (
    <div className={styles.logo}>
      <div className={styles.logoMain}>
        <span className={styles.logoTil} {...tilProps}>
          TIL.
        </span>
        <span className={styles.logoSingapore}>SINGAPORE</span>
      </div>
      <span className={styles.logoTagline}>Dance Discover Belong</span>
    </div>
  );
}

export function LaunchShell() {
  return (
    <div className={styles.launchShell} aria-label="TIL Singapore is loading" aria-busy="true">
      <LogoLockup />
    </div>
  );
}

export function Logo() {
  const hapticRef = useHapticTarget<HTMLSpanElement>(TIL_PATTERN);

  return (
    <LogoLockup
      tilProps={{
        ref: hapticRef,
        role: 'button',
        tabIndex: 0,
        'aria-label': 'TIL easter egg',
        onKeyDown: (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            triggerHapticFeedback(TIL_PATTERN);
          }
        },
      }}
    />
  );
}
